import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppRoutes, ROUTE_PATHS } from '../../shared/constants/app-routes';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => { return event; }),
      catchError((error: HttpErrorResponse) => {
        // Verificar si es un error 406 (Not Acceptable) Y si el mensaje es específicamente de credenciales inválidas
        if (error.status === 406 && this.isInvalidCredentialsError(error)) {
          // Redirigir a la página de no autorizado solo si es específicamente un error de credenciales
          this.router.navigate([ROUTE_PATHS[AppRoutes.UNAUTHORIZED]]);
        }

        return throwError(() => error);
      })
    );
  }

  /**
   * Verifica si el error es específicamente de credenciales inválidas
   * Busca el mensaje "invalid-credentials-exception" en la estructura de error
   */
  private isInvalidCredentialsError(error: HttpErrorResponse): boolean {
    const errorMessage = this.extractErrorMessage(error);
    
    // Verificar si el mensaje contiene la clave de traducción de credenciales inválidas
    return errorMessage?.includes('invalid-credentials-exception') || false;
  }

  /**
   * Extrae el mensaje de error de la estructura de respuesta
   * La estructura puede ser: error.error.error.message o error.error.message
   */
  private extractErrorMessage(error: HttpErrorResponse): string | null {
    if (!error.error) {
      return null;
    }

    // Intentar diferentes estructuras de respuesta
    const errorObj = error.error;
    
    // Estructura: error.error.error.message
    if (errorObj?.error?.error?.message) {
      return errorObj.error.error.message;
    }
    
    // Estructura: error.error.message
    if (errorObj?.error?.message) {
      return errorObj.error.message;
    }
    
    // Estructura: error.message
    if (errorObj?.message) {
      return errorObj.message;
    }
    
    // Estructura: error.error (string directo)
    if (typeof errorObj?.error === 'string') {
      return errorObj.error;
    }
    
    // Estructura: error (string directo)
    if (typeof errorObj === 'string') {
      return errorObj;
    }

    return null;
  }
}
